export default {
  isLimit: function () {
    return this.limit > 0 && Number(this.limit) === this.innerTags.length
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/components/tags/resources/computed.js